var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStorageroom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 199,
    height: 199,
    viewBox: "0 0 199 199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_418",
    "data-name": "Rectangle 418",
    width: 125,
    height: 105.793,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_416",
    "data-name": "Rectangle 416",
    width: 2.507,
    height: 4.38,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_414",
    "data-name": "Rectangle 414",
    fill: "none",
    stroke: "#033f5b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199,
    height: 199,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 198,
    height: 198,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583",
    transform: "translate(36.5 46.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M935.467,10.239h-9.7s-2.99-.181-3.806-5.255S924.413,0,926.95,0s31.441.181,33.525.453c1.525.2,3.715,3.9,3.624,5.89s0,3.534-2.356,3.715-26.276.181-26.276.181",
    transform: "translate(-861.505 0)",
    fill: "#5bc8f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M963.32,41.152l.233,1.018-1.134.276-.785.087a6.13,6.13,0,0,1-.523-1.686,2.633,2.633,0,0,1,.349-1.73c.247-.233.611-.407.8-.276a5.858,5.858,0,0,1,1.061,2.311",
    transform: "translate(-898.195 -36.256)",
    fill: "#35adfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M942.026,22.325a1.738,1.738,0,0,1-1.067-.509c-1.373-1.177-2.3-4.334-1.873-6.374a1.924,1.924,0,0,1,1.208-1.612,2.241,2.241,0,0,1,1.775.129c1.166.63,1.784,2.361,2.147,3.607a5.145,5.145,0,0,1,.177,2.963l34.186.18a.166.166,0,0,1,0,.332h0l-34.431-.181a.166.166,0,0,1-.141-.251c0-.008.493-.889-.108-2.949-.347-1.19-.93-2.837-1.987-3.409a1.9,1.9,0,0,0-1.521-.1,1.67,1.67,0,0,0-.98,1.363c-.4,1.907.491,4.962,1.765,6.054.467.4.84.52,1.108.356.6-.364.753-2.112.344-3.816-.528-2.2-1.052-2.546-1.253-2.592-.165-.038-.347.064-.542.3-.637.779-.036,2.549.153,3.049l1.216-.324a.166.166,0,1,1,.085.32l-1.359.362a.166.166,0,0,1-.2-.1c-.042-.1-1.026-2.46-.157-3.522a.882.882,0,0,1,.872-.415c.584.134,1.075,1.062,1.5,2.837.4,1.661.323,3.677-.494,4.176a.811.811,0,0,1-.43.122",
    transform: "translate(-877.525 -12.811)",
    fill: "#35adfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M1515.59,8.958s.965-.051,2.083,1.575a14.047,14.047,0,0,1,2.184,5.181c.152,1.27-1.067.914-1.321.914s-2.946-7.67-2.946-7.67",
    transform: "translate(-1416.396 -8.372)",
    fill: "#5bc8f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M993.324,1581.261c0,.521-13.644.944-30.474.944s-30.474-.423-30.474-.944,13.644-.944,30.474-.944,30.474.423,30.474.944",
    transform: "translate(-871.352 -1476.887)",
    fill: "#4a7cc7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_415",
    "data-name": "Rectangle 415",
    width: 36.741,
    height: 77.946,
    transform: "translate(77.349 14.153)",
    fill: "#172b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M1243.844,244.65V163.28h-41.354l.277,7.459h31.547s-.515,20.989,0,20.474-31.547,0-31.547,0v3.605h31.547v23.95h-31.825l.535,1.288h31.29v25.753Z",
    transform: "translate(-1123.789 -152.593)",
    fill: "#0e2239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M951.939,235.391s.164-81.32.278-82.238c.024-.193,16.654-.377,17.34-.377s-.192,81.928-.192,81.928Z",
    transform: "translate(-889.635 -142.777)",
    fill: "#172b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M959.37,1445.186l.214-10.5h3.643s-2.287,10.052-2.455,10.389c-.114.227-1.4.113-1.4.113",
    transform: "translate(-896.58 -1340.785)",
    fill: "#172b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M1214.875,1445.186l.214-10.5h3.643s-2.287,10.052-2.455,10.389c-.114.227-1.4.113-1.4.113",
    transform: "translate(-1135.362 -1340.785)",
    fill: "#154c71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M1777.318,1445.186l-.214-10.5h-3.643s2.287,10.052,2.455,10.389c.114.227,1.4.113,1.4.113",
    transform: "translate(-1657.388 -1340.785)",
    fill: "#154c71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M1621.793,1445.186l-.214-10.5h-3.643s2.287,10.052,2.455,10.389c.114.227,1.4.113,1.4.113",
    transform: "translate(-1512.043 -1340.785)",
    fill: "#172b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M987.938,1400.312H947.416a.687.687,0,0,1-.687-.687v-1.1a.687.687,0,0,1,.687-.687h40.522a.687.687,0,0,1,.687.687v1.1a.687.687,0,0,1-.687.687",
    transform: "translate(-884.766 -1306.353)",
    fill: "#172b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M1243.7,1400.312h-40.522a.687.687,0,0,1-.687-.687v-1.1a.687.687,0,0,1,.687-.687H1243.7a.687.687,0,0,1,.687.687v1.1a.687.687,0,0,1-.687.687",
    transform: "translate(-1123.789 -1306.353)",
    fill: "#154c71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M1243.7,985.3h-40.522a.687.687,0,0,1-.687-.687v-1.1a.687.687,0,0,1,.687-.687H1243.7a.687.687,0,0,1,.687.687v1.1a.687.687,0,0,1-.687.687",
    transform: "translate(-1123.789 -918.498)",
    fill: "#154c71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M1243.7,570.278h-40.522a.687.687,0,0,1-.687-.687v-1.1a.687.687,0,0,1,.687-.687H1243.7a.687.687,0,0,1,.687.687v1.1a.687.687,0,0,1-.687.687",
    transform: "translate(-1123.789 -530.644)",
    fill: "#154c71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M1243.7,155.26h-40.522a.687.687,0,0,1-.687-.687v-1.1a.687.687,0,0,1,.687-.687H1243.7a.687.687,0,0,1,.687.687v1.1a.687.687,0,0,1-.687.687",
    transform: "translate(-1123.789 -142.788)",
    fill: "#154c71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M1365.679,930.574l.108,3.128-10.043.157.5-3.285Z",
    transform: "translate(-1267.012 -869.669)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M1239.5,929.607l-19.069,0s-.495-3.286.325-3.45c.69-.138,18.547-.391,18.657-.171a1.093,1.093,0,0,1,.11.439s-8.558-.219-8.668,0a7.591,7.591,0,0,0,.11,2.743c.219.11,8.558,0,8.558,0Z",
    transform: "translate(-1140.419 -865.305)",
    fill: "#3783ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M1350.505,846.147l.078,1.59-7.247.124.36-1.714Z",
    transform: "translate(-1255.416 -790.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M1259.451,844.5l-13.761,0s-.357-1.715.234-1.844c.5-.109,13.385-.309,13.464-.135a.934.934,0,0,1,.079.347s-6.176-.173-6.255,0-.079,1.2.079,1.285,6.176,0,6.176,0Z",
    transform: "translate(-1164.06 -787.318)",
    fill: "#0085db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M1248.2,875.556l-.08,3.129,10.044.067-.528-3.28Z",
    transform: "translate(-1166.43 -818.172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M1242.712,875.352l15.351-.176c.061-.368.459-2.947-.256-3.246-.771-.322-14.931-.415-15.039-.195a1.094,1.094,0,0,0-.106.44s8.556-.3,8.668-.077a7.6,7.6,0,0,1-.085,2.744c-.218.112-8.558.076-8.558.076Z",
    transform: "translate(-1161.33 -814.568)",
    fill: "#156498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M1202.491,244.627V163.14l2.08-.01-.129,81.637Z",
    transform: "translate(-1123.789 -152.453)",
    fill: "#154c71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M1810.832,244.627V163.14l2.08-.01-.129,81.637Z",
    transform: "translate(-1692.314 -152.453)",
    fill: "#154c71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M497.711,799.6q-2.069,0-4.138,0a.175.175,0,0,0,0,.349q2.069.01,4.138.015a.184.184,0,0,0,0-.369",
    transform: "translate(-461.112 -747.264)",
    fill: "#74cafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M306.4,758.749l-13.321.332-7.293-.092s-.312-11.537-.119-12.115c.08-.24,3.573-.336,7.672-.357,5.764-.03,12.724.089,13.061.164.578.128,0,12.068,0,12.068",
    transform: "translate(-266.913 -697.654)",
    fill: "#cfd1d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M291.654,747.919c2.091-.15,4.183-.206,6.279-.19,2.12.016,4.24.1,6.357.207q1.192.062,2.383.135c-.036-.83-.106-1.364-.226-1.39-.338-.075-7.3-.194-13.061-.164-4.1.021-7.592.117-7.672.357a8.232,8.232,0,0,0-.06,1.246,49.7,49.7,0,0,0,6-.2",
    transform: "translate(-266.957 -697.654)",
    fill: "#74cafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M500.409,817.948l-4.907-.119a.177.177,0,0,0,0,.354l4.907.133a.184.184,0,0,0,0-.367",
    transform: "translate(-462.912 -764.302)",
    fill: "#74cafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M498.447,797.35l-4.907-.119a.177.177,0,0,0,0,.354l4.907.133a.184.184,0,0,0,0-.367",
    transform: "translate(-461.079 -745.053)",
    fill: "#74cafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M498.447,778.717l-4.907-.119a.177.177,0,0,0,0,.354l4.907.133a.184.184,0,0,0,0-.367",
    transform: "translate(-461.079 -727.639)",
    fill: "#74cafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M293.34,746.583l-.26,12.564-7.293-.092s-.312-11.537-.119-12.115c.08-.24,3.573-.336,7.672-.357",
    transform: "translate(-266.913 -697.72)",
    fill: "#74cafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M317.545,550.4c-.351-.176-14.649-.667-15.177-.667-.414,0-5.153.413-7.311.777-.265,2.553-.43,12.28-.033,12.28h3.087a29.048,29.048,0,0,0,4.5.321c5.493-.036,14.311-.121,14.443-.3s.222-5.484.206-9.275c0-.187.481.017.5-.161a19.538,19.538,0,0,0,.112-2.528.727.727,0,0,0-.33-.45",
    transform: "translate(-275.494 -513.753)",
    fill: "#cfd1d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M282.425,560.065a.31.31,0,0,0-.023.033,14.7,14.7,0,0,0,.09,2.421c.1.2.71-.123.784.22s-.1.857.441.539c.417-.247.555-2.577.6-3.617a6.415,6.415,0,0,0-1.889.4",
    transform: "translate(-263.911 -523.032)",
    fill: "#74cafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M316.391,553.168c-2.39-.009-4.778.025-7.167-.013-2.257-.037-4.9-.153-7.153-.2v-3.143c-.9.05-5.158.432-7.172.772-.268,2.557-.445,12.312-.049,12.312.449,0,2.812.016,2.812.016a41.187,41.187,0,0,0,4.793.273V553.3c2.248.159,4.517.183,6.768.224,2.386.043,4.781.089,7.167.023a.19.19,0,0,0,0-.379",
    transform: "translate(-275.336 -513.831)",
    fill: "#74cafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M322.432,607.234s-.064.963.064,1.091a11.9,11.9,0,0,0,3.37.161c.128-.193.321-1.22-.064-1.284a14.481,14.481,0,0,0-3.37.032",
    transform: "translate(-301.314 -567.384)",
    fill: "#41586f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M643.472,512.7l-20.456.273-4.014.053s-.326-14.355-.109-14.682,6.248-2.6,6.465-2.711a.229.229,0,0,1,.06-.008c1.246-.067,18.823,1.745,19.141,1.957a13.752,13.752,0,0,1-.109,3.48c-.021.158-.665-.094-.667.073-.053,4.469-.312,11.563-.312,11.563",
    transform: "translate(-578.318 -463.183)",
    fill: "#cfd1d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M643.552,500.669c-5.882-.612-12.272-.969-18.133-1.758v-3.263a.234.234,0,0,0-.06.008c-.217.109-6.248,2.385-6.465,2.711S619,513.05,619,513.05l7.069-.053-.126-13.542c5.852.853,11.726,1.24,17.607,1.862.414.044.411-.6,0-.647",
    transform: "translate(-578.317 -463.209)",
    fill: "#74cafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M642.581,571.72s-.093,1.2.185,1.2a11.544,11.544,0,0,0,3.15-1.112c.093-.278.185-1.39,0-1.39a27.8,27.8,0,0,0-3.335,1.3",
    transform: "translate(-600.51 -533.089)",
    fill: "#41586f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M602.157,739.717c-.163.336-9.734.534-10.5.534l-.187,0c-2.069-.051-18.594-.649-18.594-.649.034,0,.075-12.942.075-12.942s17.141-.842,18.333-.869h.047c.653,0,10.658.87,10.658.87s.326,12.724.164,13.06",
    transform: "translate(-535.386 -678.285)",
    fill: "#dfe0e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M865,739.717c-.163.336-9.735.534-10.5.534l-.187,0-.186-14.46h.047c.653,0,10.658.87,10.658.87s.326,12.724.164,13.06",
    transform: "translate(-798.23 -678.285)",
    fill: "#cbcdcf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579",
    transform: "translate(60.886 47.89)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M930.352,731.72a38.142,38.142,0,0,0-.022,4.24.158.158,0,0,0,.026.092c.054.065.159.008.221-.05l.243-.229a.9.9,0,0,0,.205.255.306.306,0,0,0,.309.05c.13-.063.211-.25.352-.224s.179.216.309.226c.1.008.171-.1.231-.191a.088.088,0,0,1,.046-.039.078.078,0,0,1,.052.01c.069.034.12.1.191.13.249.106.186-.715.189-.861l.033-1.317.047-1.876v-.009l-2.433-.205",
    transform: "translate(-930.278 -731.72)",
    fill: "#dfe0e1"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M637.731,887.755c-.163.327-.715.216-1.013.224a2.256,2.256,0,0,1-.564.018c-.238-.081-.217-.229-.246-.418a11.636,11.636,0,0,1-.008-1.967c.474-.043,1.631-.211,1.873.126.165.23.048.674.032.956a3.572,3.572,0,0,1-.075,1.061m.406-2.135c-.075-.246-.274-.251-.509-.279a7.487,7.487,0,0,0-1.718-.023l-.025.005a.164.164,0,0,0-.232.148q0,.866,0,1.732c0,.27-.083.7.143.906.269.246.823.123,1.142.12.265,0,.8.106,1-.126s.126-.742.146-1.014a4.723,4.723,0,0,0,.058-1.469",
    transform: "translate(-594.036 -827.338)",
    fill: "#cbcdcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M587.881,886.094c-.163.327-.715.216-1.013.224a2.25,2.25,0,0,1-.564.017c-.238-.081-.217-.229-.246-.418a11.63,11.63,0,0,1-.008-1.967c.474-.043,1.631-.211,1.873.126.165.231.048.674.032.956a3.572,3.572,0,0,1-.075,1.061m.406-2.135c-.075-.246-.274-.25-.509-.279a7.476,7.476,0,0,0-1.718-.023l-.025.005a.164.164,0,0,0-.232.148q0,.866,0,1.732c0,.27-.083.7.143.906.269.246.823.123,1.142.119.265,0,.8.106,1-.126s.126-.742.146-1.015a4.722,4.722,0,0,0,.058-1.469",
    transform: "translate(-547.449 -825.786)",
    fill: "#cbcdcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M709.611,797.717c-2.815-.059-5.624.248-8.433.37a.187.187,0,0,0,.011.374c2.728-.047,5.444-.365,8.174-.318a.221.221,0,0,0,.073.01l.188-.006a.215.215,0,0,0-.012-.43",
    transform: "translate(-655.123 -745.5)",
    fill: "#cbcdcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M708.73,768.951c-2.815-.059-5.624.248-8.433.37a.187.187,0,0,0,.011.374c2.728-.047,5.444-.365,8.174-.318a.221.221,0,0,0,.073.01l.188-.006a.215.215,0,0,0-.012-.43",
    transform: "translate(-654.299 -718.617)",
    fill: "#cbcdcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M426.314,903.293l-.075,2.088,6.7.116-.329-2.193Z",
    transform: "translate(-398.342 -844.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M422.879,902.7l12.728.025s.334-2.193-.213-2.3c-.46-.093-12.379-.282-12.452-.136a.73.73,0,0,0-.074.293s5.712-.137,5.785.01a5.067,5.067,0,0,1-.076,1.831c-.147.073-5.712-.01-5.712-.01Z",
    transform: "translate(-395.189 -841.31)",
    fill: "#97a2ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M500.557,866.707l.05,2.089-6.7.033.356-2.189Z",
    transform: "translate(-461.577 -809.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M451.609,866.654l-10.245-.135c-.04-.246-.3-1.967.175-2.166a94.232,94.232,0,0,1,10.038-.113.729.729,0,0,1,.07.294s-5.71-.207-5.785-.062a5.071,5.071,0,0,0,.054,1.832c.146.075,5.712.061,5.712.061Z",
    transform: "translate(-412.375 -807.596)",
    fill: "#6380c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M672.557,1048.4l.941,33.7H671.39l-2.517-34.807Z",
    transform: "translate(-625.096 -978.752)",
    fill: "#172b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M256.868,940.2h1.524c-.084,1.617-.247,5.37.042,5.8.163.245,11.03.364,21.682.387l1.051,0-.926,33.129h2.108l2.4-33.126c7.57,0,20.328-.049,24.9-.128l2.406,33.261h2.108l-.932-33.356a4.24,4.24,0,0,0,.84-.077c.369-.3.212-4.314.135-5.895h2.536v-2.671H256.868Z",
    transform: "translate(-240.056 -876.172)",
    fill: "#154c71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M256.868,937.533h20.354v3.131h2.947s-.3,5.558-.055,5.727c0,0,0,0,0,0-6.169-.013-13.267-.059-17.1-.142l-2.407,33.28h-2.108l.933-33.4a3.472,3.472,0,0,1-1-.123c-.288-.432-.125-4.185-.042-5.8h-1.524Z",
    transform: "translate(-240.056 -876.172)",
    fill: "#172b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M335.737,981.676l49.838-.358a.184.184,0,0,1,0,.368l-49.837.358h-1.367a.107.107,0,0,1-.107-.125c.012-.126-.176-.242,1.471-.243",
    transform: "translate(-312.387 -917.092)",
    fill: "#172b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M1424.284,1601.255c.059.463-7.013.506-15.8.506s-15.617.067-15.687-.506c-.054-.443,6.807-.506,15.6-.506s15.811-.135,15.893.506",
    transform: "translate(-1301.638 -1495.97)",
    fill: "#507bd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M1771.174,1416.214c0-.13.005-.259,0-.389a2.541,2.541,0,0,0-.736-1.515,9.541,9.541,0,0,1-1.174-1.256c-.1-.138-.19-.28-.279-.423a5.212,5.212,0,0,1-.729-1.214l-5.087-.43a19.667,19.667,0,0,1,2.527,5.121c.808,2.918-1.34,7.12.566,7.6,1.8.453,4.515-5.353,4.885-7.346.009-.05.018-.1.026-.146",
    transform: "translate(-1647.772 -1318.639)",
    fill: "#368cf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M1543.926,849.175s-2.77,6.349-5.162,5.608l-.016-.006a.4.4,0,0,1-.047-.025.49.49,0,0,1-.06-.041l-.03-.023c-1.075-.879-5.553-7.346-9.4-13.566-2.841-4.6-5.335-9.057-5.854-11.026-.878-3.337,1.243-20.611,1.243-20.611l8.9-.1-.962,19.285s.457.8,1.188,2.092c2.791,4.917,9.571,16.906,10.178,18.378.006.015.012.029.016.04",
    transform: "translate(-1423.458 -756.407)",
    fill: "#3a89d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M1630.552,1154.416s-2.77,6.349-5.162,5.608l-.016-.006a.378.378,0,0,1-.047-.025c-.019-.012-.039-.025-.061-.041l-.029-.024c-1.075-.879-5.553-7.346-9.4-13.566,1.2-2.656,3.114-7.106,4.519-10.365,2.791,4.917,9.571,16.906,10.178,18.378.006.015.012.029.016.04",
    transform: "translate(-1510.084 -1061.648)",
    fill: "#2d77c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M1533.323,833.594a39.7,39.7,0,0,0,3.778,1.451l.095-.414a.581.581,0,0,1,.7-.435l.021,0a11.254,11.254,0,0,0,2.632.477c.4-1.2,1.205-4.474,2.148-8.763.025-.112.049-.224.073-.337.775-3.543,1.635-7.742,2.424-12.01.013-.065.024-.129.036-.194.663-3.6,1.276-7.235,1.746-10.566q.077-.548.149-1.083c.135-1.01.267-1.675.37-2.608.438-3.936,1.314-7.979.928-9.584l-5.408-1.043-.005,0-4.221-1.464s-.049.586-.135,1.608c-.233,2.771-.741,8.748-1.292,14.948l-.005.063c-.287,3.223-.585,6.5-.863,9.421q-.077.807-.162,1.606-.033.312-.067.621h0c-1.008,9.138-2.713,17.235-2.921,18.2l-.018.081a.036.036,0,0,0,0,.009l0,.007",
    transform: "translate(-1432.968 -735.515)",
    fill: "#3a89d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M1803.71,1434.4c0-.13,0-.259,0-.389a2.543,2.543,0,0,0-.736-1.515,9.525,9.525,0,0,1-1.174-1.256c-.1-.14-.192-.283-.283-.428-.1-.123-.19-.247-.269-.365-1.427,3.02-2.578,3.649-3.037,3.778.006.023.014.046.02.069.808,2.918-1.341,7.12.566,7.6,1.8.453,4.515-5.353,4.885-7.346.01-.05.018-.1.026-.147",
    transform: "translate(-1680.309 -1336.827)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M1574.225,931.274h-.019a.177.177,0,0,1-.157-.2c.391-3.614.818-8.654,1.194-13.1.21-2.479.391-4.621.536-6.15a.177.177,0,0,1,.353.033c-.144,1.527-.326,3.668-.535,6.146-.377,4.449-.8,9.491-1.195,13.108a.177.177,0,0,1-.176.158",
    transform: "translate(-1471.028 -852)",
    fill: "#2965af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M1771.783,1455.54a.852.852,0,0,1-.443-.7,1.463,1.463,0,0,1,1.043-1.424,1.037,1.037,0,0,0,.321-.178.848.848,0,0,0,.194-.391,6.4,6.4,0,0,0,.168-3.559,1.369,1.369,0,0,1-.1-.766,1.034,1.034,0,0,1,.445-.516l.1-.068a2.141,2.141,0,0,1,1.258-.489c.318.021.612.184.929.216a1.332,1.332,0,0,0,1.21-.618,1.825,1.825,0,0,0,.214-1.376c-.029-.128-.192-.72-.089-.876.038-.058.114-.057.246.051a8.533,8.533,0,0,1,.95,1.1c.307.348.615.7.908,1.056l.01.012a2.126,2.126,0,0,1,.373.593,1.974,1.974,0,0,1-.052,1.221,44.892,44.892,0,0,1-3.306,5.7,2.557,2.557,0,0,1-1.5,1.049,6.925,6.925,0,0,1-1.131.045l-1.345.025a1.555,1.555,0,0,1-.4-.1",
    transform: "translate(-1655.401 -1350.193)",
    fill: "#5bc8f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M1439.407,1500.588a14.448,14.448,0,0,1-.147-1.637,14.632,14.632,0,0,1,.051-1.741,21.959,21.959,0,0,0-4.545-.711l-.027.109v0l0,.006c-.059.232-.119.46-.181.676a5.481,5.481,0,0,1-3.9,4.057l-.147.057c-.049.019-.1.037-.144.054-1.585.573-2.62,1.3-2.528,1.96s6.1.654,8.28.588,3.378.224,3.571-1c0-.023.007-.045.009-.069a11.933,11.933,0,0,0-.292-2.35",
    transform: "translate(-1334.384 -1398.531)",
    fill: "#3caefc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M1533.294,1498.531l0,.009,0-.006v0",
    transform: "translate(-1432.939 -1400.453)",
    fill: "#00c5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M1533.323,1496.971l.027-.109a.227.227,0,0,0-.027.109",
    transform: "translate(-1432.969 -1398.894)",
    fill: "#00c5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M1437.339,1523.5c2.174-.063,3.377.229,3.573-1,0-.023.007-.045.009-.069a11.931,11.931,0,0,0-.289-2.351,14.415,14.415,0,0,1-.145-1.637s0,0,0-.006c-3.077-1.184-4.457-1.151-4.877-1.092a4.565,4.565,0,0,1-.255.632,7.035,7.035,0,0,1-3.473,2.853l-.147.057c-.049.019-.1.037-.144.053-1.586.57-2.532,1.036-2.441,1.7s6.014.922,8.189.858",
    transform: "translate(-1335.608 -1418.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M1417.246,1525.835c.174.355,4.5.436,6.921.45.969.006,5.4-.009,5.484-.095a4.076,4.076,0,0,0,.144-1.276,13.065,13.065,0,0,0-.166-2.565.357.357,0,0,0-.059-.149c-.139-.186-.427-.04-.618.09a2.412,2.412,0,0,1-1.894.379,1.959,1.959,0,0,1-1.405-1.28c-.1-.338-.13-.745-.422-.942a1.083,1.083,0,0,0-.385-.136,1.438,1.438,0,0,0-.97.021,1.6,1.6,0,0,0-.485.495,5.769,5.769,0,0,1-3.206,2.369,5.058,5.058,0,0,0-2.469.943,1.792,1.792,0,0,0-.439.753,1.812,1.812,0,0,0-.029.943",
    transform: "translate(-1324.443 -1420.739)",
    fill: "#5bc8f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M1685.211,895.856a.177.177,0,0,1-.091-.026,5.646,5.646,0,0,1-2.109-2.617.177.177,0,0,1,.333-.123,5.381,5.381,0,0,0,1.959,2.436.177.177,0,0,1-.092.329",
    transform: "translate(-1572.849 -834.53)",
    fill: "#2965af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M1578.939,933.764a.133.133,0,0,1-.105-.052l-1.167-1.507a.133.133,0,1,1,.21-.163l1.167,1.507a.133.133,0,0,1-.1.215",
    transform: "translate(-1474.384 -870.993)",
    fill: "#2965af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M1771.79,1487.553a.852.852,0,0,1-.443-.7,1.149,1.149,0,0,1,0-.2c.489.014,2.565-.015,2.693-.015.427,0,1.111-.171,2.65-2.565a26.085,26.085,0,0,0,2.1-4.124c.188-.463.31-.8.359-.937l.01.012a2.127,2.127,0,0,1,.373.592,1.975,1.975,0,0,1-.052,1.221,44.892,44.892,0,0,1-3.306,5.7,2.557,2.557,0,0,1-1.5,1.049,6.939,6.939,0,0,1-1.131.044l-1.345.025a1.542,1.542,0,0,1-.4-.1",
    transform: "translate(-1655.408 -1382.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M1417.246,1592.3c.174.355,4.5.436,6.921.45.969.006,5.4-.009,5.484-.095a4.077,4.077,0,0,0,.144-1.276c-.912.05-6.586.33-9.211.25a20.579,20.579,0,0,1-3.308-.272,1.812,1.812,0,0,0-.029.943",
    transform: "translate(-1324.443 -1487.205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M1396.071,448.255s-.343-1.889,3.262-2.618,6.438-.9,7.039-.343-.086,1.331.043,1.8.858,1.03.815,1.331,3,1.5,3.992,2.06,1.76,5.751,1.974,6.181,2.146.944,2.361,2.232-1.245,4.163-1.674,5.022-2.79,1.674-3.777,1.331-2.661-6.095-3.047-5.837a7.708,7.708,0,0,0-1.459,5.108,13.875,13.875,0,0,0,1.159,3.906,5.916,5.916,0,0,1-.558,2.919c-.172.3-3.219.944-6.91.944s-7.554-.816-7.9-1.116a2.981,2.981,0,0,1-.558-2.232,19.161,19.161,0,0,0,.987-3.734c.429-2.318.773-5.537.773-5.537s-2.189,3.691-3.949,4.593-3.648-.386-4.249-1.416a9.62,9.62,0,0,0-2.232-2.189,3.234,3.234,0,0,1-1.2-1.931c-.043-.73,1.688-2.84,1.974-3.047.754-.547,3.863,2.618,4.678,2.79a50.929,50.929,0,0,0,3.176-5.623,6.333,6.333,0,0,1,2.962-3.477c.815-.472,2.318-1.116,2.318-1.116",
    transform: "translate(-1290.579 -415.84)",
    fill: "#89b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M1819.474,638.588a1.627,1.627,0,0,0-1.557,1.307c-.049.185-.062.375-.093.563a1.159,1.159,0,0,1-.218.517c-.112.151-.24.289-.349.442a4.164,4.164,0,0,0-.312.511,6.851,6.851,0,0,0-.478,1.237.126.126,0,0,0,.243.067,6.81,6.81,0,0,1,.387-1.047,4.578,4.578,0,0,1,.6-.922,1.816,1.816,0,0,0,.283-.428,1.945,1.945,0,0,0,.118-.526,1.969,1.969,0,0,1,.362-.974,1.23,1.23,0,0,1,1.015-.5c.162.007.162-.245,0-.252",
    transform: "translate(-1697.575 -596.791)",
    fill: "#4794cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M1551.539,597.449a.169.169,0,0,0-.207.117l-.741,4.851-.211,1.383a.173.173,0,0,0,.117.207.169.169,0,0,0,.207-.117l.741-4.851.211-1.383a.174.174,0,0,0-.118-.207",
    transform: "translate(-1448.907 -558.342)",
    fill: "#172b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M1480.33,646.9c-.753-.286-1.641-.618-2.619-.991-.151-.058-.215.182-.067.243q1.293.537,2.619.991c.154.053.218-.186.067-.243",
    transform: "translate(-1380.855 -603.624)",
    fill: "#4794cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M1691.78,477.271a7.96,7.96,0,0,0-1.647-.644q.364-.2.718-.421c.138-.085.011-.3-.127-.218a17.573,17.573,0,0,1-1.925,1.032c-.635.291-1.3.508-1.936.79a4.019,4.019,0,0,0-.965.583c-.125.1.055.282.178.178a5.97,5.97,0,0,1,1.766-.879,17.872,17.872,0,0,0,1.942-.876l.132-.071a7.765,7.765,0,0,1,1.78.671c.1.05.181-.095.085-.145",
    transform: "translate(-1575.517 -444.817)",
    fill: "#4794cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M1617.105,497.366c-.738-.554-1.628-.839-2.411-1.317-.139-.085-.266.133-.127.218.782.478,1.673.763,2.411,1.317.13.1.256-.121.127-.218",
    transform: "translate(-1508.839 -463.565)",
    fill: "#4794cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M1545.758,815.753a8.822,8.822,0,0,1-1.7-.276,12.207,12.207,0,0,1-1.656-.726c-.1-.046-.183.1-.085.145a12.545,12.545,0,0,0,1.7.743,9.038,9.038,0,0,0,1.74.282c.108.01.107-.158,0-.168",
    transform: "translate(-1441.338 -761.418)",
    fill: "#4794cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M1647.652,825.522a5.507,5.507,0,0,1-1.387.326,7.881,7.881,0,0,1-1.452-.03,8.616,8.616,0,0,0-1.457,0c-.494.041-.987.087-1.482.1a16.313,16.313,0,0,1-1.684-.043c-.108-.008-.108.16,0,.168a18.276,18.276,0,0,0,3-.043,8.923,8.923,0,0,1,1.5-.027,9.334,9.334,0,0,0,1.459.05,5.66,5.66,0,0,0,1.549-.342c.1-.037.057-.2-.045-.162",
    transform: "translate(-1532.766 -771.487)",
    fill: "#4794cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M1563.182,545.96c-1.55-.94-1.956-2.862-2.15-4.528q-.019-.166-.037-.332a2.229,2.229,0,0,0-.042-.336c-.066-.243-.288-.238-.5-.25-.494-.028-.989-.029-1.483-.014-.711.021-1.42.073-2.129.124.043-.166.089-.332.138-.5a23.967,23.967,0,0,0,.969-3.635,22.579,22.579,0,0,0,.092-3.747,21.478,21.478,0,0,1,.139-4.258c.018-.106-.144-.151-.162-.045-.421,2.5.058,5.041-.181,7.556a11.273,11.273,0,0,1-.334,1.846c-.164.614-.367,1.216-.557,1.821q-.152.483-.282.971c-.228.016-.456.032-.684.046a18.83,18.83,0,0,1-3.346-.026.125.125,0,0,0-.121.093,14.818,14.818,0,0,1-.478,2.131,11.341,11.341,0,0,1-.767,1.974,1.463,1.463,0,0,1-.669.711c-.148.065-.02.283.127.218.6-.265.856-.968,1.087-1.531a14.7,14.7,0,0,0,.7-2.171c.092-.384.166-.772.227-1.162a21.842,21.842,0,0,0,3.859-.026c-.049.2-.1.4-.137.594-.132.642-.231,1.291-.333,1.939q-.348,2.215-.7,4.429c-.017.106.145.151.162.045l.625-3.974c.161-1.021.314-2.043.558-3.046.582-.041,1.164-.084,1.745-.111.494-.023.989-.033,1.484-.021q.173,0,.345.013l.183.01c.047,0,.134-.009.166.032a.3.3,0,0,1,.022.122c.006.052.011.1.017.156.014.13.029.26.044.39a9.732,9.732,0,0,0,.608,2.667,4.281,4.281,0,0,0,1.662,2.039.126.126,0,0,0,.127-.218",
    transform: "translate(-1449.053 -493.799)",
    fill: "#4794cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M1385.72,637.212s-.806,1.085-1.172.8.141-1.237.506-1.828Z",
    transform: "translate(-1293.813 -594.55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M1361.319,578.235a11.521,11.521,0,0,1-2.383-1.532,3.337,3.337,0,0,1-.559-2.48c.219-.778,1.386-1.143,1.386-1.143l2.042,3.477Z",
    transform: "translate(-1269.411 -535.573)",
    fill: "#3caefc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M1316.208,599.26a2.046,2.046,0,0,0-.219.8s-4.632-1.039-4.8-1.331.4-.857.839-.857,4.176,1.386,4.176,1.386",
    transform: "translate(-1225.35 -558.744)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M1281.97,476.568s-2.662-8.516-2.735-8.643-3.957-1.276-4.084-1.276a2.684,2.684,0,0,0-.875.93c0,.164,2.042,8.388,2.17,8.552s5,1.386,5.106,1.386a.311.311,0,0,0,.2-.109s-4.65-1.258-4.8-1.313.292-.511.438-.6,4.34,1.222,4.413,1.258.164-.182.164-.182",
    transform: "translate(-1190.875 -436.106)",
    fill: "#0085db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M1290.286,478.247l-1.522-6.016-.432-1.707a.126.126,0,0,0-.243.067l1.522,6.016.432,1.707a.126.126,0,0,0,.243-.067",
    transform: "translate(-1203.781 -439.644)",
    fill: "#1d6895"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M1363.581,554.455a16.866,16.866,0,0,0,1.094-1.75c.146-.389-.486-1.07-.8-1.6s-.754-1.872-1.143-2.018a4.639,4.639,0,0,1-1.264-1.216c-.219-.292-.559-.34-.705.049s.292,1.118.656,1.337a2.093,2.093,0,0,1,.584.535l.608,1.921s.754,1.288.778,1.361.194,1.386.194,1.386",
    transform: "translate(-1271.673 -511.793)",
    fill: "#3caefc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M1872.979,645.962a1.16,1.16,0,0,0,.966.3c.515-.129.944-1.116,1.009-1.588a1.779,1.779,0,0,0-.537-1.373c-.343-.343-1.288-.215-1.588.751a2.184,2.184,0,0,0,.15,1.91",
    transform: "translate(-1750.125 -601.036)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M1774.8,485.758l3.693,13.77-.172.172-1,.014-5.508-1.059,2-12.662Z",
    transform: "translate(-1655.846 -453.966)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M1769.728,494.495s5.457,1.183,5.577,1.207-.918-.024-.918-.024l-5.432-1.111,1.932-12.482.241-.072-.435-.169-.266.1-1.907,12.941s5.6,1.062,5.915,1.087,1.159-.024,1.231-.169,1.883-11.927,1.835-12.1a53.093,53.093,0,0,0-5.577-2.1.8.8,0,0,0-.338.169Z",
    transform: "translate(-1652.773 -450.081)",
    fill: "#4c6fb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M1848.813,574.488a11.773,11.773,0,0,1-2.213-1.307c-.324-.4.027-.647.3-.539s-.459-.378-.459-.863.081-.539-.135-.863-.027-.782.27-.7,2,1.079,2.1,1.133a2.9,2.9,0,0,0-.944-.917c-.4-.189-.674-.594-.593-.809s.243-.351,1.052.108a7.619,7.619,0,0,1,1.592,1.106c.081.135-.108.513.054.62s.54.594.324.836-.432.324-.27.674.324.593.108.809a7.619,7.619,0,0,0-.243,2.185c-.027.432-.723.953-1.326.953.161-1.1.383-2.424.383-2.424",
    transform: "translate(-1725.377 -532.152)",
    fill: "#3caefc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M1628.837,453.824s1.865-.735,2.423-1.014a1.062,1.062,0,0,0,.47-1.36c-.227-.261-3.051-.261-5.316.3s-3.138.8-3.469,1.255-.244.837-.052.959.869.394,1.228.589,4.716-.726,4.716-.726",
    transform: "translate(-1516.516 -421.745)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M1580.059,309.77a2.621,2.621,0,0,0,.589-1.795c-.027-1.152-1.232-1.045-1.232-1.045a2.171,2.171,0,0,0-.241-1.259.643.643,0,0,0-.766-.122c.013-.022.026-.044.04-.065a1.415,1.415,0,0,1,.131-.166c.054-.061.11-.119.167-.177a.126.126,0,0,0-.178-.178,2.46,2.46,0,0,0-.375.458c-.139-.335-.486-.987-1.107-1.037a2.889,2.889,0,0,0-2.611,1.058.881.881,0,0,0-.7-.023,2.949,2.949,0,0,0-.757.321,3.017,3.017,0,0,0-1.121,1.182c-.075.144.142.271.218.127a2.766,2.766,0,0,1,.658-.825,1.921,1.921,0,0,0-.591,1.255,1.7,1.7,0,0,0-.274.263,6.693,6.693,0,0,0-.486.644A2.027,2.027,0,0,0,1571.1,310c.038.158.281.091.243-.067a1.778,1.778,0,0,1,.291-1.42c.038-.058.078-.114.118-.171a3.663,3.663,0,0,0-.3.97.975.975,0,0,0,.643,1.152,1.124,1.124,0,0,0,.884,1.286l6.108,2.063a13.56,13.56,0,0,0,1.339-2.679c.322-1.1-.375-1.366-.375-1.366",
    transform: "translate(-1468.225 -284.452)",
    fill: "#164c73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M1646.885,410.513a55.283,55.283,0,0,0,1.913,5.211s-2.573,1.022-3.331,2.144a17.383,17.383,0,0,0-1.385-1.418s.561-.363.1-2.21Z",
    transform: "translate(-1536.477 -383.645)",
    fill: "#3caefc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M1645.759,418.808a2.708,2.708,0,0,0,.658-.168,3.416,3.416,0,0,0,1.222-.808,2.535,2.535,0,0,0,.614-1.3,6.058,6.058,0,0,0,.066-1.777,7.564,7.564,0,0,0-.137-.88c-.011-.051-.023-.1-.036-.153l-2.552,3.517a4.443,4.443,0,0,1,.165,1.57",
    transform: "translate(-1537.891 -386.643)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M1600.69,384.051c-.7-.905-1.285.818-1.285.818s-.413-.033-.849-1.211a4.4,4.4,0,0,1-2.838.086,1.965,1.965,0,0,1-.458.216,1.738,1.738,0,0,1-1.031,0,1.814,1.814,0,0,1-.191.227s.358,4.559,1.331,5.416a3.1,3.1,0,0,0,2.306.209,3.024,3.024,0,0,0,2.51-3.517s1.787-.582.506-2.24",
    transform: "translate(-1489.71 -358.548)",
    fill: "#3caefc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M1603.561,429.278a.328.328,0,0,0-.005-.05.689.689,0,0,0-.015-.117.254.254,0,0,0-.046-.1.163.163,0,0,0-.13-.068.165.165,0,0,0-.137.084.288.288,0,0,0-.033.087.372.372,0,0,0,0,.147.011.011,0,0,1,0,0,.268.268,0,0,0,.024.125.206.206,0,0,0,.173.113.158.158,0,0,0,.117-.047.185.185,0,0,0,.047-.12.3.3,0,0,0,0-.056",
    transform: "translate(-1498.26 -400.868)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M1648.11,418.413a.427.427,0,0,0-.062-.183.238.238,0,0,0-.143-.124.164.164,0,0,0-.131.022.221.221,0,0,0-.083.117.314.314,0,0,0-.015.078s0,0,0,0a.33.33,0,0,0,0,.053.453.453,0,0,0,.02.1.074.074,0,0,0,0,.007.226.226,0,0,0,.057.1.375.375,0,0,0,.1.093.127.127,0,0,0,.172-.045.455.455,0,0,0,.022-.048.237.237,0,0,0,.063-.17",
    transform: "translate(-1539.836 -390.736)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M1628.864,442.206l-.026-.02a.126.126,0,0,0-.064-.017l-.23-.029a.125.125,0,0,0-.089.037.126.126,0,0,0,0,.178l.026.02a.126.126,0,0,0,.064.017l.23.029a.125.125,0,0,0,.089-.037.126.126,0,0,0,0-.178",
    transform: "translate(-1521.84 -413.202)",
    fill: "#4a81cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M1630.948,453.666a.127.127,0,0,0-.172.045.938.938,0,0,1-.952.544.127.127,0,0,0-.126.126.129.129,0,0,0,.126.126,1.181,1.181,0,0,0,1.17-.669.13.13,0,0,0-.045-.173",
    transform: "translate(-1523.036 -423.959)",
    fill: "#2e78c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M1616.529,379.856a2.2,2.2,0,0,1-.883-.193,2.315,2.315,0,0,1-.391-.227.776.776,0,0,1-.3-.319c-.054-.152-.3-.086-.243.067a.9.9,0,0,0,.325.4,2.411,2.411,0,0,0,.459.285,2.5,2.5,0,0,0,1.036.24.126.126,0,0,0,0-.252",
    transform: "translate(-1509.02 -354.223)",
    fill: "#164c73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M1643.226,401.039a2.328,2.328,0,0,0-.935-.263.169.169,0,0,0-.168.168.172.172,0,0,0,.168.168l.107.009.019,0,.012,0,.046.007a2.109,2.109,0,0,1,.413.116l.027.011.046.02c.032.015.064.031.1.048a.168.168,0,0,0,.17-.29",
    transform: "translate(-1534.647 -374.545)",
    fill: "#164c73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M1594.355,411.838a.168.168,0,0,0-.238,0l-.363.4a.176.176,0,0,0-.049.119.171.171,0,0,0,.049.119.168.168,0,0,0,.238,0l.363-.4a.177.177,0,0,0,.049-.119.171.171,0,0,0-.049-.119",
    transform: "translate(-1489.398 -384.838)",
    fill: "#164c73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M33.512,1278.854c.174-2,.129-16.967-.036-20.983-1.514-.232-20.214-.908-20.815-.858-.621.052-11.8.155-12.318.31-.075.023-.153.132-.231.3-.2,4.05-.117,20.3.085,21.155,2.862.213,31.852.082,33.314.076",
    transform: "translate(0 -1174.74)",
    fill: "#cfd1d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M12.534,1258.692l.068-1.586c-1.061.053-11.752.155-12.258.307-.075.023-.153.131-.231.3-.2,4.05-.117,20.3.085,21.155,1.127.084,6.3.115,12.251.12Z",
    transform: "translate(0 -1174.829)",
    fill: "#74cafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M74.593,1264.023c.005.117.011.233.021.349a1.367,1.367,0,0,0,.033.4.111.111,0,0,0,.125.064.163.163,0,0,0,.063-.049l.212-.23a1.019,1.019,0,0,0,.254.293.216.216,0,0,0,.1.051c.141.017.223-.208.365-.192.126.014.18.211.306.205.146-.007.176-.273.322-.268.063,0,.109.058.151.1.177.2.167-.029.168-.152l0-.389q.006-.554.013-1.108l.032-2.744q.01-.846.02-1.691c-.719.012-1.449.025-2.151.039-.023.481-.025.964-.036,1.444-.022.977-.037,1.955-.028,2.933,0,.315.008.63.022.944",
    transform: "translate(-69.688 -1176.285)",
    fill: "#cfd1d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M98.423,1528.21l.01.993a.442.442,0,0,1-.105.358.406.406,0,0,1-.228.07,2.867,2.867,0,0,1-1.009-.1.5.5,0,0,1-.233-.117c-.128-.133-.095-.346-.1-.514-.014-.535-.033-1.059-.068-1.594-.007-.1,0-.225.084-.278a.276.276,0,0,1,.118-.03q.408-.041.819-.042a1.5,1.5,0,0,1,.6.088.174.174,0,0,1,.087.065.194.194,0,0,1,.018.1q0,.5.01,1m-.05-1.471a4.665,4.665,0,0,0-1.544-.021c-.122.018-.344.083-.365.226a10.192,10.192,0,0,0-.046,2.239.591.591,0,0,0,.387.591,4.017,4.017,0,0,0,1.6.089c.319-.056.36-.246.364-.547.009-.625-.014-1.252-.021-1.876,0-.363.012-.614-.373-.7",
    transform: "translate(-90.07 -1426.745)",
    fill: "#71bee0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M146.14,1530.269q0,.5.01.993a.441.441,0,0,1-.105.358.4.4,0,0,1-.228.07,2.867,2.867,0,0,1-1.009-.1.5.5,0,0,1-.233-.117c-.128-.132-.095-.346-.1-.514-.014-.534-.033-1.058-.068-1.594-.007-.1,0-.225.084-.278a.278.278,0,0,1,.118-.03q.408-.041.819-.041a1.5,1.5,0,0,1,.6.088.175.175,0,0,1,.087.065.194.194,0,0,1,.018.1q0,.5.01,1m-.05-1.471a4.665,4.665,0,0,0-1.544-.021c-.122.018-.344.083-.365.226a10.193,10.193,0,0,0-.046,2.239.591.591,0,0,0,.387.591,4.021,4.021,0,0,0,1.6.089c.319-.056.36-.246.364-.547.009-.625-.014-1.252-.021-1.876,0-.363.012-.614-.373-.7",
    transform: "translate(-134.664 -1428.67)",
    fill: "#71bee0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M33.957,1413.186q-3.77-.268-7.55-.254a.218.218,0,0,0,0,.437q3.779.015,7.55.292c.3.023.3-.453,0-.474",
    transform: "translate(-24.482 -1320.456)",
    fill: "#71bee0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M31.872,1386.427c-2.811-.671-5.723-.127-8.572-.428-.291-.031-.288.423,0,.454,2.814.308,5.661-.147,8.458.385.266.051.383-.347.113-.411",
    transform: "translate(-21.573 -1295.285)",
    fill: "#71bee0"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageroom);
export default __webpack_public_path__ + "static/media/storageroom.4b11c96fec8dd482e500c818bd808a14.svg";
export { ForwardRef as ReactComponent };